// API server exports
import { Hono } from 'hono';
import { cors } from 'hono/cors';
import { logger } from 'hono/logger';
import { createApiResponse, createErrorResponse } from '../middleware/index.js';
import { generateToken } from '../auth/index.js';
import { setupRoutes } from '../routes/index.js';

export function createServer() {
  const app = new Hono();

  // Middleware
  app.use('*', logger());
  app.use('*', cors({
    origin: '*',
    allowMethods: ['GET', 'POST', 'PUT', 'DELETE', 'OPTIONS'],
    allowHeaders: ['Content-Type', 'Authorization']
  }));

  // Health check
  app.get('/api/v1/health', (c) => {
    return c.json(createApiResponse({
      status: 'healthy',
      timestamp: new Date().toISOString(),
      uptime: process.uptime(),
      version: '1.0.0'
    }));
  });

  // Setup additional routes
  setupRoutes(app);

  // Error handler
  app.onError((err, c) => {
    console.error('API Error:', err);
    return c.json(createErrorResponse(
      500,
      'Internal Server Error',
      err.message
    ), 500);
  });

  return app;
}

export type ApiServer = ReturnType<typeof createServer>;

export class PodxAPIServer {
  private server: any;
  private app: ApiServer;

  constructor() {
    this.app = createServer();
  }

  start(port: number): any {
    this.server = Bun.serve({
      port,
      fetch: this.app.fetch
    });
    
    console.log(`🚀 Server running on http://localhost:${port}`);
    return this.server;
  }

  stop(): void {
    if (this.server) {
      this.server.stop();
    }
  }

  async generateCommunityToken(
    userId: string,
    tier: 'free' | 'premium' | 'admin',
    duration: '1h' | '1d' | '7d' | '30d' | 'unlimited'
  ): Promise<string> {
    const expiresIn = duration === 'unlimited' ? '999y' : duration;
    return generateToken({ sub: userId, tier }, expiresIn);
  }
}